import { render, staticRenderFns } from "./Submits.vue?vue&type=template&id=efaf1132"
import script from "./Submits.vue?vue&type=script&lang=js"
export * from "./Submits.vue?vue&type=script&lang=js"
import style0 from "./Submits.vue?vue&type=style&index=0&id=efaf1132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports